export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "fr": {
        "individual_tracking": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Suivi individuel"])},
        "show_more": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Voir plus"])},
        "show_less": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Voir moins"])}
      },
      "en": {
        "individual_tracking": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Individual tracking"])},
        "show_more": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Show more"])},
        "show_less": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Show less"])}
      }
    }
  })
}
